import { MessageFormat, WorldReady } from '@paypalcorp/worldready';
import Page from './page';

const locale = Page.getLocale();

const getIntlMessage = (key, value) => {
  const id = key.split(/\/|\./);
  let messageFormat;
  try {
    const worldReady = new WorldReady(locale);
    messageFormat = new MessageFormat(worldReady, {
      id,
    });
  } catch (error) {
    throw new ReferenceError(`Could not create messageformat for: ${key}`);
  }
  if (value) {
    return messageFormat.format(value);
  }
  return messageFormat.format();
};

const createl10n = () => ({
  getContent(...args) {
    return getIntlMessage(...args);
  },
});

const l10n = createl10n();

export default l10n;
